export default __webpack_public_path__ + "static/media/vin2.e4e55c04.webp";